module.exports = __webpack_public_path__ + "images/Yandex-Zen.d9475216b46af3460452b8a092cc67f1.png";